<div class="container">
  <!--
  <div class="alert alert-warning" role="alert">
    <h4>Not ready yet</h4>
    <p>
      This service is still in development. Please use the
      <a href="https://chipster.csc.fi" class="alert-link">Java client</a> for any real work for now.
    </p>

    <p>
      You are welcome to try this and give feedback. Please bear in mind caveats:
    </p>
    <ul>
      <li>a lot of service breaks and no announcements about them</li>
      <li>jobs and data are sometimes deleted due to version updates, maintenance or bugs</li>
    </ul>
  </div>
-->

  @if (homeHeaderPath) {
    <div>
      <ch-manual
        [assetsPath]="homeHeaderPath"
        [page]="homeHeaderFile"
        [showControls]="false"
        [addContainer]="false"
        [routerPath]="homeRouterPath"
        [manualStyles]="false"></ch-manual>
    </div>
  }

  <div class="row" id="getstarted">
    <div class="col">
      <div class="panel panel-default mb-3">
        <div class="panel-heading">
          <h3>Get started</h3>
        </div>

        <!-- Service break noticification (see also a redirection in AuthGuard) -->
        <!-- <div class="alert alert-warning">
          <p>
            <b>The service is temporarily unavailable due to storage maintenance.</b>
          </p>
        </div> -->

        <div class="panel-body">
          @if (tokenHasExpired()) {
            <p>
              <i>Login expired, please log in again.</i>
            </p>
          }

          @if (!isLoggedIn()) {
            <button class="btn btn-sm btn-primary" [routerLink]="routerLinkLogin">Log In</button>
          } @else {
            <p>
              You are logged in as
              <strong>{{ getAccountName() }}</strong>
              <span>.</span>
              <!-- span is a hack for preventing prettier formatting adding extra space-->
              Go to
              <a [routerLink]="routerLinkAnalyze">Analyze</a>
              or
              <a [routerLink]="routerLinkSessions">Sessions</a>
              to continue.
            </p>
          }
        </div>
      </div>
    </div>
  </div>

  @if (homePath && homeFile && homeRouterPath) {
    <div>
      <ch-manual
        [assetsPath]="homePath"
        [page]="homeFile"
        [showControls]="false"
        [addContainer]="false"
        [routerPath]="homeRouterPath"
        [manualStyles]="false"></ch-manual>
    </div>
  }
</div>
